import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubSink} from '@Common/core/utils/subsink';
import {StyleService} from "../common/services/style.service";
import {Interlignage, PoliceNames, style} from "../common/models/style.model";
import {ActivatedRoute, Router} from "@angular/router";
import {Planning} from "app/suaps/common/services/planning/plannig.model";
import {PlanningFOService} from "app/suaps/common/services/planning/planning-fo.service";

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit, OnDestroy {
  subSink = new SubSink();
  mainStyle: style = <style>{};
  interlignage: Interlignage = Interlignage.default;
  police: PoliceNames = PoliceNames.default;

  activityDetail: Planning;
  activityReadOnly = false;
  constructor(
    private styleService: StyleService,
    private route: ActivatedRoute,
    private planningSvc: PlanningFOService,
    private router: Router,
    ) {}

  ngOnInit() {
    this.subSink.sink = this.styleService.mainStyle$.subscribe((_mainStyle)=> {
      this.mainStyle = _mainStyle;
    });
    this.subSink.sink = this.styleService.interlignage$.subscribe((_interlignage)=> {
      this.interlignage = _interlignage;
    });
    this.subSink.sink = this.styleService.police$.subscribe((_police)=> {
      this.police = _police;
    });

    const id = this.route.snapshot.params['id'];
    console.log('app-accueil planning id: ', id);
    if (id) {
      this.subSink.sink = this.planningSvc.get(id).subscribe((planning) => {
        this.activityDetail = planning;
        this.activityReadOnly = true;
      });
    } else {
      this._resetActivity();
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  private _resetActivity() {
    this.activityDetail = <Planning>{id: 0};
    this.activityReadOnly = false;
  }

  goHome() {
    this._resetActivity();
    this.router.navigateByUrl('/');
  }
}
